var _circle, _path, _path2, _path3, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-hidden": "true",
    role: "img",
    className: "iconify iconify--emojione",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 30,
    fill: "#f5f5f5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.4 33.7c2.8 1.9 6.7 1.1 8.6-1.7c1.9-2.8 5.7-3.6 8.6-1.7c2.7 1.8 3.5 5.3 2 8c3.3-5.6 1.8-12.9-3.8-16.6c-5.7-3.8-13.4-2.3-17.2 3.4c-.1.2-.2.4-.3.5c-1.4 2.9-.5 6.3 2.1 8.1",
    fill: "#ed4c5c"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3 38.9c.1-.2.2-.4.3-.5c-.1.1-.2.3-.3.5",
    fill: "#003478"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6 30.3c-2.8-1.9-6.7-1.1-8.6 1.7c-1.9 2.8-5.7 3.6-8.6 1.7c-2.7-1.8-3.5-5.3-2-8c-3.4 5.6-1.8 12.9 3.8 16.6c5.7 3.8 13.4 2.3 17.2-3.4c.1-.2.2-.4.3-.5c1.4-2.9.5-6.3-2.1-8.1",
    fill: "#428bc1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#3e4347"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.8 23.3L14.7 13l-.7-.5l-.7-.4l-6.9 10.3l.7.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.7 24.6l.7.4l6.8-10.3l-.6-.4l-.7-.5L9 24.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4 15.5l-6.8 10.3l.7.5l.7.4l6.8-10.3l-.7-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.5 42.5l.7.5l3.2-4.8l-.7-.5l-.7-.4l-3.2 4.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.2 40.7L53 45.5l.7.5l.7.4l3.2-4.8l-.7-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8 44.7l3.2-4.8l-.7-.5l-.7-.4l-3.2 4.8l.7.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.1 43.2l-.7-.4l-3.2 4.8l.7.4l.7.5l3.2-4.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.6 44.9l-.6-.4l-3.2 4.8l.6.4l.7.5l3.2-4.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.5 46.2L49.3 51l.7.5l.7.4l3.2-4.8l-.7-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.1 41.2l-.7.4l6.9 10.3l.7-.4l.7-.5l-6.9-10.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4 44.9l-.7.5l3.2 4.8l.7-.5l.6-.4l-3.2-4.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3 37.7l-.7.5l6.8 10.3l.7-.5l.7-.4L13 37.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 39.9l3.2 4.8l.7-.5l.7-.4l-3.2-4.8l-.7.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2 17.4l.7-.5l-3.2-4.8l-.7.4l-.7.5l3.2 4.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.1 20.8l.7-.5l-3.2-4.8l-.7.5l-.7.4l3.2 4.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53 18.5l3.2 4.8l.7-.5l.7-.4l-3.2-4.8l-.7.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.3 24.6l.7-.5l-6.9-10.3l-.7.5l-.6.4L53.6 25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.7 26.3l.7-.5l-3.2-4.8l-.7.5l-.7.4l3.2 4.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKo);
export default __webpack_public_path__ + "static/media/ko.20c4141f06ac0930c3425fb1904330d0.svg";
export { ForwardRef as ReactComponent };